import { BASE_URLS } from "../../../components/env";
import { withAIQueryTracking } from "../../../utils/userEventTracker";

/**
 * Calls POST /api/generate-ai-recap/ (Claude on server). Same endpoint as AI recap.
 * @param {"recap"|"both"|"clinical_only"} mode
 * @param {number} [modelChoice] — optional; forwarded as model_choice (0 Haiku / 1–2 Sonnet per backend claude_chat_v3 map)
 */
export async function fetchGenerateAiRecap(transcriptText, mode = "both", modelChoice) {
  const t = (transcriptText || "").trim();
  if (!t) throw new Error("No transcript text");
  const hostname = window.location.hostname;
  const baseUrl =
    hostname === "localhost"
      ? BASE_URLS.local.backend
      : BASE_URLS.render.backend;
  const payload = { transcript: t, mode };
  if (
    modelChoice !== undefined &&
    modelChoice !== null &&
    Number.isFinite(Number(modelChoice))
  ) {
    const mc = Math.floor(Number(modelChoice));
    if (mc >= 0 && mc <= 2) {
      payload.model_choice = mc;
    }
  }
  const res = await withAIQueryTracking("live_save_ai", () =>
    fetch(`${baseUrl}/api/generate-ai-recap/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }),
  );
  const json = await res.json();
  if (!res.ok || json.error) {
    throw new Error(json.error || "AI request failed");
  }
  return json;
}

/**
 * Runs recap (+ clinical tabs when clinicalEnabled) and sends results to the external popup.
 * @param {(msg: object) => void} sendToPopup - e.g. ref.sendMessage or popup.postMessage wrapper
 */
export async function runLiveAiAnalysis(
  sendToPopup,
  transcriptText,
  { clinicalEnabled = true, modelChoice = 1 } = {},
) {
  if (!transcriptText?.trim()) return null;
  const send = typeof sendToPopup === "function" ? sendToPopup : () => {};
  send({ type: "AI_RECAP_GENERATING" });
  if (clinicalEnabled) {
    send({ type: "LIVE_CLINICAL_TABS_GENERATING" });
  }
  try {
    const mode = clinicalEnabled ? "both" : "recap";
    const json = await fetchGenerateAiRecap(transcriptText, mode, modelChoice);
    if (json.recap) {
      send({ type: "AI_RECAP_READY", recap: json.recap });
    }
    if (clinicalEnabled && json.clinical_tabs) {
      send({
        type: "LIVE_CLINICAL_TABS_READY",
        clinical: json.clinical_tabs,
      });
    }
    return json;
  } catch (err) {
    send({
      type: "AI_RECAP_ERROR",
      error: err.message || "Something went wrong generating the recap.",
    });
    if (clinicalEnabled) {
      send({
        type: "LIVE_CLINICAL_TABS_ERROR",
        error: err.message || "Clinical tabs could not be generated.",
      });
    }
    throw err;
  }
}
